module.exports = __webpack_public_path__ + "img/ccic-logo-color.ce07b4d3.svg";